import axios from "axios";
import * as AppConstants from "AppConstants";
import { getAuthenticationUrl } from "utils/endpointUtils/authEndpointUtil";
import { isEmpty, isNullOrUndefined } from 'utils/validationUtil';
import { setGlobalAuthorizationHeader } from "app/services/auth.header.service";
import { setUserContext } from "app/services/user.service";
import * as sessionStorageProxy from "app/services/app.session.storage.proxy";
import { logout, resetSessionStorage } from "app/services/session.service";

// Re-exported from session.service so existing importers of auth.service keep working.
export { logout, resetSessionStorage };

export const authenticate = (email, password) => {
    return new Promise((resolve, reject) => {
        if((isNullOrUndefined(email) || email?.trim() === "") || (isNullOrUndefined(password) || password?.trim() === "")) {
            window.alert("Email or password can not be empty");
            reject("Email or password can not be empty");
        }
        // Get url to authentication
        const url = getAuthenticationUrl();
    
        const authObject = {
            "email": email,
            "password": password
        };
    
        axios
        .post(url, authObject)
        .then((response) =>  {

            init(email, response)
            .then((result) => resolve(result))
            .catch(error => {
                reject("init() failed with error " + error);
            })
        }).catch(error => {
            reject("POST /authenticate failed with error " + error);
        })
    });
    
}

//
const init = (email, response) => {
    return new Promise((resolve, reject) => {
        resetSessionStorage();
        if(isEmpty(response)) reject(new Error("Empty response while init")); // resolve(false); 

        sessionStorageProxy.setItem(AppConstants.SESSION_KEY_TOKEN, response.data.authToken);
        sessionStorageProxy.setItem(AppConstants.SESSION_KEY_IS_LOGIN, true);
        setGlobalAuthorizationHeader(response.data.authToken);

        resolve(Promise.resolve(setUserContext(email, response.data.authToken)));
    });
}
